// extracted by mini-css-extract-plugin
export default {"left_content_wrapper":"Login_left_content_wrapper__y2o46","logo":"Login_logo__8TfU5"};